import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import api from "../api/Api.js";
// import "./DriverAttendancePageDaily.css";
import "./SalarySlipPage.css";
import BrandLogo from "../assets/Logo Patra Travels (half white logo).png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const SalarySlip = () => {
    const navigate = useNavigate();
      const { month, year } = useParams();
      const initialMonth = month ? Number(month) : new Date().getMonth();
const initialYear = year ? Number(year) : new Date().getFullYear();
  const tableRef = useRef();
  const [saveConfirmAttendance, setSaveConfirmAttendance] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const today = new Date();

  const [selectedMonth, setSelectedMonth] = useState(initialMonth);

  const [selectedYear, setSelectedYear] = useState(initialYear);

  // const months = [
  //   { value: "01", label: "January" },
  //   { value: "02", label: "February" },
  //   { value: "03", label: "March" },
  //   { value: "04", label: "April" },
  //   { value: "05", label: "May" },
  //   { value: "06", label: "June" },
  //   { value: "07", label: "July" },
  //   { value: "08", label: "August" },
  //   { value: "09", label: "September" },
  //   { value: "10", label: "October" },
  //   { value: "11", label: "November" },
  //   { value: "12", label: "December" },
  // ];


  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = Array.from({ length: 7 }, (_, i) =>
    String(today.getFullYear() - 5 + i)
  );

  useEffect(() => {
    fetchSaveConfirmAttendance();
  }, [selectedMonth, selectedYear]);

  const fetchSaveConfirmAttendance = async () => {
    try {
      const res = await api.get(
        `/adminmodSalary/getConfirmSalaryData/${selectedMonth}/${selectedYear}`
      );
      setSaveConfirmAttendance(res.data?.data || []);
    } catch (err) {
      toast.error("Failed to load Salary Data");
    }
  };

  /* ================= FIX START ================= */

let drivers = [];

if (saveConfirmAttendance.length > 0) {
  try {
    const salaryData = saveConfirmAttendance[0].salary_data;

    const parsedSalary =
      typeof salaryData === "string"
        ? JSON.parse(salaryData)
        : salaryData;

    drivers = parsedSalary?.drivers || [];
  } catch (err) {
    console.error("Salary JSON parse error", err);
  }
}

  /* ================= FIX END ================= */

  const filteredDrivers = drivers.filter((d) => {
    const term = searchTerm.toLowerCase();
    return (
      d.driver_name?.toLowerCase().includes(term) ||
      d.driver_regno?.toLowerCase().includes(term)
    );
  });

  /* ================= PDF DOWNLOAD ================= */

  const handlePrintPDF = async () => {
    const element = tableRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 1,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.6);

    const pdf = new jsPDF("l", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`salary_slip_of_${selectedMonth}_${selectedYear}.pdf`);
  };

 

  return (
    <div>
      <div className="pageTitle">
        <h2 className="title1">
          Salary Slip –{" "}
          {new Date(`${selectedYear}-${selectedMonth}-01`).toLocaleDateString(
            "en-IN",
            { month: "long", year: "numeric" }
          )}
        </h2>
      </div>

      <div className="attendance-wrapper">

        {/* Controls */}

        <div className="controls-container">
          <div className="control-group">
            <label>Month:</label>

           <select
  className="custom-input"
  value={selectedMonth}
  onChange={(e) => setSelectedMonth(e.target.value)}
>
  <option value="">--Select Month--</option>

  {months.map((m) => (
    <option key={m.value} value={m.value}>
      {m.label}
    </option>
  ))}
</select>

            <label>Year:</label>

            <select
              className="custom-input"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div className="control-group">
            <label>Search Driver:</label>

            <input
              type="text"
              className="custom-input"
              placeholder="Name or Reg No"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-warning" onClick={handlePrintPDF}>
              <i className="fa fa-print"></i>
            </button>
          </div>
        </div>

        {/* ===== SLIP AREA ===== */}
         <div ref={tableRef}>
<div className="attendance-scroll">
          <table className="attendance-table-daily" style={{ width: "100%" }}>
            <thead>
              <tr>
               <th>#</th>
                <th>Driver Name</th>
                <th>Salary Per Month</th>
                <th>Present (Days)</th>
                <th>Leave (Days)</th>
                <th>Paid Leaves (Days)</th>
                <th>Salary Days</th>
                <th>Leave Deduction</th>
                <th>Extra Allowance</th>
                <th>Gross Salary</th>
                <th>Total Deduction</th>
                <th>Net Salary</th>
                <th>Action</th>
              </tr>
            </thead>
                       <tbody>
  {filteredDrivers && filteredDrivers.length > 0 ? (
    filteredDrivers.map((d, i) => {
      const deductions = d.deductions || {};
      const totalDeduction = deductions.total || 0;

      return (
        
        <tr key={d.driver_regno} >
          <td>{i + 1}</td>

          <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
            {d.driver_name}
            <br/>
            {d.driver_regno}
          </td>
      <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.salary_in_month).toFixed(2)}</td>
          <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{filteredDrivers[i]?.worked_days}</td>
              <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{filteredDrivers[i]?.leave_days}</td>
                  <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{filteredDrivers[i]?.paid_leave}</td>
                      <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{filteredDrivers[i]?.total_salary_process}</td>
                          <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.leave_deduction).toFixed(2)}</td>
                              <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.extra_allowance).toFixed(2)}</td>
                                  <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.gross_salary).toFixed(2)}</td>
                                      <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.deductions?.total).toFixed(2)}</td>
                                          <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>{Number(filteredDrivers[i]?.net_salary).toFixed(2)}</td>
        
                                 <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>   
                            <button
  className="btn btn-success btn-sm"
  title=" View Salary Slip"
  onClick={() =>
    window.open(
      `/salary/salary-slip-details/${d.driver_regno}/${selectedMonth}/${selectedYear}`,
      "_blank"
    )
  }
>
 <i class="fa fa-eye" aria-hidden="true"></i>
</button>
                                 </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="13" className="no-data">
        No Confirm Salary records available for selected month & year.
      </td>
    </tr>
  )}
</tbody>
            </table>
            </div>
       
</div>
      </div>
    </div>
  );
};

export default SalarySlip;